var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3147",
    "data-name": "Rectangle 3147",
    width: 24,
    height: 24,
    transform: "translate(1748 732)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speakerIcon",
    transform: "translate(-1748 -732)",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1748 732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M9.143,10.286V28.072a.214.214,0,0,0,.214.214h5.361a.429.429,0,0,0,.419-.52l-1.67-6.338h1.248A.429.429,0,0,0,15.144,21V10.286Z",
    transform: "translate(-4 -4.286)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M29.081,10.565l-.224-.056V2.5a.214.214,0,0,0-.214-.214H26.366a.214.214,0,0,0-.141.053l-6.8,5.947v8.571l6.8,5.947a.214.214,0,0,0,.141.053h2.277a.214.214,0,0,0,.214-.214V14.634l.224-.056a2.1,2.1,0,0,0,0-4.012Z",
    transform: "translate(-6.571 -2.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M5.714,10.286H3.357a.214.214,0,0,0-.214.214v1.906a2.3,2.3,0,0,0-.227.233,2.916,2.916,0,0,0-.63,1.932,2.81,2.81,0,0,0,.857,2.165v1.906a.214.214,0,0,0,.214.214H5.714Z",
    transform: "translate(-2.286 -4.286)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speakerIcon.fd5857e959cef231789b68ae6e242eed.svg";
export { ForwardRef as ReactComponent };